import type { ComponentProps } from 'react';
import {
  DeferRender,
  MiniPriceChartDefinitions,
  NarrativeMiniPriceChart,
} from '@components/MiniPriceChart';
import type { HoverParam } from '@components/MiniPriceChart';
import { CURRENT_PERIOD } from '../../constants';

const CHART_HEIGHT = 68;

type Props = {
  companyId: string;
  status: 'pending' | 'error' | 'success';
  onHover?: (param: HoverParam) => void;
  valuations: ComponentProps<typeof NarrativeMiniPriceChart>['valuations'];
  isNegativeMovement?: boolean;
};

const ChartBones = ({ height }: { height: number }) => (
  <div
    className="min-h-[--chart-h]"
    style={{ '--chart-h': `${height}px` } as React.CSSProperties}
  />
);

export const NarrativeKeyMetricChart = ({
  companyId,
  status,
  valuations,
  onHover,
  isNegativeMovement,
}: Props) => {
  if (status === 'pending') {
    return <ChartBones height={CHART_HEIGHT} />;
  }

  if (status === 'error') {
    return (
      <div
        className="grid min-h-[--chart-h] place-items-center"
        style={{ '--chart-h': `${CHART_HEIGHT}px` } as React.CSSProperties}
      >
        <p className="text-xs text-bad">An error occurred</p>
      </div>
    );
  }

  return (
    <div id="price-narrative-key-metric-chart">
      <MiniPriceChartDefinitions />
      <DeferRender fallback={<ChartBones height={CHART_HEIGHT} />}>
        <NarrativeMiniPriceChart
          companyId={companyId}
          period={CURRENT_PERIOD}
          align="left"
          valuations={valuations}
          onHover={onHover}
          height={CHART_HEIGHT}
          isNegativeMovement={isNegativeMovement}
        />
      </DeferRender>
    </div>
  );
};
